export default __webpack_public_path__ + "static/media/recruit_section_image_3@2x.dd6bbc74.webp";